// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_invitation_model from "./web_invitation_model.js";
import * as Mapre_web__Web_members_controller from "./web_members_controller.js";
import * as Mapre_web__Web_members_model from "./web_members_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  Stdlib__Option.iter(Mapre_web__Web_members_controller.cancel, t.members);
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function path(t) {
  const w = Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route);
  if (w !== undefined) {
    return "/api/workspaces/" + (w + "/invitations");
  } else {
    return Stdlib.invalid_arg("invitations_without_workspace");
  }
}

function message(code) {
  if (/* tag */ typeof code !== "object" && typeof code !== "function") {
    switch (code) {
      case /* Forbidden */ 1 :
        return "Use a GitHub account with the invited email verified.";
      case /* Unauthorized */ 0 :
      case /* Invalid_response */ 2 :
        return "Unable to access this invitation.";
    }
  } else {
    if (code.TAG === /* Missing */ 0) {
      return "Invitation not found.";
    }
    const code$1 = code._0;
    switch (code$1) {
      case "github_email_permission_required" :
        return "GitHub email access is required. Ask an administrator to enable Email addresses read, then sign in again.";
      case "invitation_email_not_configured" :
        return "Invitation email is not configured.";
      case "invitation_expired_or_revoked" :
        return "This invitation has expired or was revoked.";
      default:
        return code$1;
    }
  }
}

function denied(t) {
  const match = Curry._1(t.model, undefined).invitation_form;
  if (match === undefined) {
    return Curry._1(t.emit, {
      TAG: /* Invitations */ 48,
      _0: {
        TAG: /* Failed */ 8,
        _0: "Use a GitHub account with the invited email verified.",
        _1: false
      }
    });
  }
  let tmp = match.mode;
  if (!/* tag */ (typeof tmp !== "object" && typeof tmp !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Invitations */ 48,
      _0: {
        TAG: /* Failed */ 8,
        _0: "Use a GitHub account with the invited email verified.",
        _1: false
      }
    });
  }
  Curry._1(t.emit, {
    TAG: /* Invitations */ 48,
    _0: {
      TAG: /* Failed */ 8,
      _0: "Permission denied. Your workspace role changed.",
      _1: false
    }
  });
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
    if (generation === t.generation) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(t.emit, {
            TAG: /* Workspaces */ 1,
            _0: Mapre_web__Web_codec.workspaces(result._0)
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        Curry._1(t.failure, result._0);
      }
    }
    return Promise.resolve();
  });
}

function request(t, body, url, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, url).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).invitation_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            const action_1 = body !== undefined;
            const action = {
              TAG: /* Failed */ 8,
              _0: "Invalid invitation response.",
              _1: action_1
            };
            Curry._1(t.emit, {
              TAG: /* Invitations */ 48,
              _0: action
            });
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        let exit = 0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          switch (error) {
            case /* Unauthorized */ 0 :
              Curry._1(t.failure, /* Unauthorized */ 0);
              break;
            case /* Forbidden */ 1 :
              denied(t);
              break;
            default:
              exit = 1;
          }
        } else {
          exit = 1;
        }
        if (exit === 1) {
          let uncertain = false;
          if (body !== undefined) {
            let tmp;
            if (/* tag */ typeof error !== "object" && typeof error !== "function" || error.TAG !== /* Failed */ 1) {
              tmp = false;
            } else {
              switch (error._0) {
                case "Connection unavailable. Retry when online." :
                case "invitation_acceptance_uncertain" :
                case "invitation_creation_uncertain" :
                  tmp = true;
                  break;
                default:
                  tmp = false;
              }
            }
            uncertain = tmp;
          }
          const action_0 = message(error);
          const action$1 = {
            TAG: /* Failed */ 8,
            _0: action_0,
            _1: uncertain
          };
          Curry._1(t.emit, {
            TAG: /* Invitations */ 48,
            _0: action$1
          });
        }
        
      }
    }
    return Promise.resolve();
  });
}

function list(t, more) {
  const form = Curry._1(t.model, undefined).invitation_form;
  if (form === undefined) {
    return;
  }
  const suffix = more ? Stdlib__Option.fold("", (function (cursor) {
      return "?after_id=" + cursor;
    }), form.cursor) : "";
  Curry._1(t.emit, {
    TAG: /* Invitations */ 48,
    _0: /* Loading */ 5
  });
  request(t, undefined, path(t) + suffix, (function (json) {
    const action_0 = Stdlib__List.map(Mapre_web__Web_invitation_model.decode, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "invitations")));
    const action_1 = Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor"));
    const action = {
      TAG: /* Listed */ 5,
      _0: action_0,
      _1: action_1,
      _2: more
    };
    Curry._1(t.emit, {
      TAG: /* Invitations */ 48,
      _0: action
    });
  }));
}

function receive(t, token) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Invitations */ 48,
    _0: {
      TAG: /* Receive */ 1,
      _0: token
    }
  });
  Curry._1(t.emit, {
    TAG: /* Invitations */ 48,
    _0: /* Loading */ 5
  });
  request(t, JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "token",
      Mapre_wire__Json.str(token)
    ],
    tl: /* [] */ 0
  })), "/api/invitations/inspect", (function (json) {
    const action = {
      TAG: /* Preview */ 7,
      _0: Mapre_web__Web_invitation_model.preview(json)
    };
    Curry._1(t.emit, {
      TAG: /* Invitations */ 48,
      _0: action
    });
  }));
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Close */ 0) {
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Invitations */ 48,
        _0: /* Close */ 0
      });
    }
    
  } else {
    switch (action.TAG) {
      case /* Open */ 0 :
        if (Mapre_web__Web_model.can_manage_members(Curry._1(t.model, undefined))) {
          cancel(t);
          const action$1 = {
            TAG: /* Open */ 0,
            _0: crypto.randomUUID()
          };
          Curry._1(t.emit, {
            TAG: /* Invitations */ 48,
            _0: action$1
          });
          list(t, false);
          return Stdlib__Option.iter((function (c) {
            Mapre_web__Web_members_controller.dispatch(c, /* Refresh */ 0);
          }), t.members);
        }
        break;
      case /* Receive */ 1 :
        return receive(t, action._0);
      case /* Members */ 9 :
        const action$2 = action._0;
        return Stdlib__Option.iter((function (c) {
          Mapre_web__Web_members_controller.dispatch(c, action$2);
        }), t.members);
    }
  }
  const form = Curry._1(t.model, undefined).invitation_form;
  if (form === undefined) {
    return;
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Submit */ 1 :
        if (!(Mapre_web__Web_model.can_manage_members(Curry._1(t.model, undefined)) && Mapre_web__Web_invitation_model.can_submit(form))) {
          return;
        }
        Curry._1(t.emit, {
          TAG: /* Invitations */ 48,
          _0: /* Pending */ 6
        });
        const body = JSON.stringify(Js__Js_dict.fromList({
          hd: [
            "request_id",
            Mapre_wire__Json.str(form.request_id)
          ],
          tl: {
            hd: [
              "email",
              Mapre_wire__Json.str(form.email)
            ],
            tl: {
              hd: [
                "role",
                Mapre_wire__Json.str(form.role)
              ],
              tl: /* [] */ 0
            }
          }
        }));
        return request(t, body, path(t), (function (param) {
          list(t, false);
          const action = {
            TAG: /* Created */ 6,
            _0: crypto.randomUUID()
          };
          Curry._1(t.emit, {
            TAG: /* Invitations */ 48,
            _0: action
          });
        }));
      case /* Accept */ 2 :
        const match = form.mode;
        const match$1 = form.preview;
        if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match$1 !== undefined && !form.pending)) {
          return;
        } else {
          Curry._1(t.emit, {
            TAG: /* Invitations */ 48,
            _0: /* Pending */ 6
          });
          return request(t, JSON.stringify(Js__Js_dict.fromList({
            hd: [
              "token",
              Mapre_wire__Json.str(match._0)
            ],
            tl: /* [] */ 0
          })), "/api/invitations/accept", (function (json) {
            Curry._1(t.navigate, {
              TAG: /* Workspace */ 1,
              _0: Mapre_wire__Json.string(Mapre_wire__Json.get(json, "workspace"), "id")
            });
          }));
        }
      case /* Refresh */ 3 :
        if (form.pending) {
          return;
        }
        const token = form.mode;
        if (/* tag */ typeof token !== "object" && typeof token !== "function") {
          return list(t, false);
        } else {
          return receive(t, token._0);
        }
      case /* More */ 4 :
        if (!form.loading && form.cursor !== undefined) {
          return list(t, true);
        } else {
          return;
        }
      default:
        return;
    }
  } else {
    switch (action.TAG) {
      case /* Email */ 2 :
      case /* Role */ 3 :
        return Curry._1(t.emit, {
          TAG: /* Invitations */ 48,
          _0: action
        });
      case /* Revoke */ 4 :
        let id = action._0;
        let version = action._1;
        if (Mapre_web__Web_model.can_manage_members(Curry._1(t.model, undefined)) && !form.pending) {
          Curry._1(t.emit, {
            TAG: /* Invitations */ 48,
            _0: /* Pending */ 6
          });
          return request(t, JSON.stringify(Js__Js_dict.fromList({
            hd: [
              "expected_version",
              version
            ],
            tl: /* [] */ 0
          })), path(t) + ("/" + (id + "/revoke")), (function (param) {
            list(t, false);
            Curry._1(t.emit, {
              TAG: /* Invitations */ 48,
              _0: /* Revoked */ 7
            });
          }));
        } else {
          return;
        }
      default:
        return;
    }
  }
}

function create(emit, model, failure, navigate) {
  const t = {
    emit,
    model,
    failure,
    navigate,
    generation: 0,
    controller: new AbortController(),
    members: undefined
  };
  t.members = Caml_option.some(Mapre_web__Web_members_controller.create((function (action) {
    Curry._1(emit, {
      TAG: /* Invitations */ 48,
      _0: {
        TAG: /* Members */ 9,
        _0: action
      }
    });
  }), (function (param) {
    return Stdlib__Option.fold(Mapre_web__Web_members_model.initial, (function (f) {
      return f.members;
    }), Curry._1(model, undefined).invitation_form);
  }), (function (param) {
    const workspace = Mapre_web__Web_types.workspace(Curry._1(model, undefined).route);
    if (workspace !== undefined) {
      return "/api/workspaces/" + (workspace + "/members");
    } else {
      return Stdlib.invalid_arg("members_without_workspace");
    }
  }), (function (error) {
    if (/* tag */ typeof error !== "object" && typeof error !== "function" && error === /* Forbidden */ 1) {
      return denied(t);
    } else {
      return Curry._1(failure, error);
    }
  }), (function (param) {
    return Mapre_web__Web_model.can_manage_members(Curry._1(model, undefined));
  })));
  return t;
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
